var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.58325 17.8333H5.45825C5.15988 17.8333 4.87374 17.7147 4.66276 17.5037C4.45178 17.2928 4.33325 17.0066 4.33325 16.7083V5.45825C4.33325 5.15988 4.45178 4.87374 4.66276 4.66276C4.87374 4.45178 5.15988 4.33325 5.45825 4.33325H16.7083C17.0066 4.33325 17.2928 4.45178 17.5037 4.66276C17.7147 4.87374 17.8333 5.15988 17.8333 5.45825V6.58325M9.95825 22.3333H21.2083C21.5066 22.3333 21.7928 22.2147 22.0037 22.0037C22.2147 21.7928 22.3333 21.5066 22.3333 21.2083V9.95825C22.3333 9.65988 22.2147 9.37374 22.0037 9.16276C21.7928 8.95178 21.5066 8.83325 21.2083 8.83325H9.95825C9.65988 8.83325 9.37374 8.95178 9.16276 9.16276C8.95178 9.37374 8.83325 9.65988 8.83325 9.95825V21.2083C8.83325 21.5066 8.95178 21.7928 9.16276 22.0037C9.37374 22.2147 9.65988 22.3333 9.95825 22.3333Z",
    stroke: "#8B8B8B",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateIcon);
export default __webpack_public_path__ + "static/media/duplicate-icon.c9b8a637dcfe7de86bcf48118e1707de.svg";
export { ForwardRef as ReactComponent };